import React from 'react';
import { formatDate } from '../utils/FormatDateTime';
import { CheckCircle2, Clock } from 'lucide-react';

const DeviceHistoryModalContent = ({ device }) => {

    const history = device?.history || [];

    if (history.length === 0) {
        return <div style={{ padding: '40px', textAlign: 'center', color: '#64748b' }}>No payment history available for this device.</div>;
    }

    return (
        <div style={{ padding: '24px' }}>
            <div style={{ marginBottom: '20px', borderBottom: '1px solid #f1f5f9', paddingBottom: '16px' }}>
                <h3 style={{ margin: 0, fontSize: '18px', color: '#0f172a' }}>Transaction History</h3>
                <p style={{ margin: '4px 0 0', fontSize: '13px', color: '#64748b' }}>
                    Device ID: <span style={{ fontFamily: 'monospace', fontWeight: 600, color: '#2563eb' }}>{device.device_id}</span>
                </p>
            </div>

            <div style={{ overflowX: 'auto', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left' }}>
                    <thead>
                        <tr style={{ background: '#f8fafc' }}>
                            <th style={hStyle}>Payment Date</th>
                            <th style={hStyle}>Order ID</th>
                            <th style={hStyle}>Amount</th>
                            <th style={hStyle}>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {history.map((record) => (
                            <tr key={record.id} style={{ borderBottom: '1px solid #f1f5f9' }}>
                                <td style={rStyle}>{formatDate(record.payment_date)}</td>
                                <td style={{ ...rStyle, fontFamily: 'monospace', fontSize: '12px' }}>{record.payment_order_id}</td>
                                <td style={{ ...rStyle, fontWeight: 700 }}>₹{record.amount}</td>
                                <td style={rStyle}>
                                    <span style={{
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        gap: '4px',
                                        padding: '4px 10px',
                                        borderRadius: '99px',
                                        fontSize: '11px',
                                        fontWeight: 600,
                                        background: record.payment_status === 'COMPLETED' ? '#dcfce7' : '#fef9c3',
                                        color: record.payment_status === 'COMPLETED' ? '#16a34a' : '#a16207'
                                    }}>
                                        {record.payment_status === 'COMPLETED' ? <CheckCircle2 size={12} /> : <Clock size={12} />}
                                        {record.payment_status}
                                    </span>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

const hStyle = { padding: '12px 16px', fontSize: '11px', fontWeight: 700, textTransform: 'uppercase', color: '#64748b' };
const rStyle = { padding: '14px 16px', fontSize: '13px', color: '#334155' };

export default DeviceHistoryModalContent;